// extracted by mini-css-extract-plugin
export default {"container":"InnerPageSection_container__Kl24g"};